import * as React from 'react';
import { Suspense } from 'react';
import { LoadingFallback } from '@components/LoadingFallback';
import { RelayErrorBoundary } from '@components/RelayErrorBoundary';
import type { SuspenseBoundaryProps } from './types';

export function SuspenseBoundary( {
    children,
    fallback,
}: SuspenseBoundaryProps ): React.ReactElement {
    return (
        <RelayErrorBoundary>
            <Suspense fallback={ fallback ?? <LoadingFallback /> }>
                {children}
            </Suspense>
        </RelayErrorBoundary>
    );
}
